import Weapon from "./Weapon";
export default Weapon;
